<template>
	<div>
		<el-select
			v-model="id"
			filterable
			remote
			default-first-option
			:allow-create="params.allowCreate"
			size="mini"
			:clearable="true"
			:placeholder="params.placeholder?params.placeholder:'请搜索管理员'"
			@change="handleChange"
			:remote-method="refreshData"
			:loading="loadings.main"
		>
			<el-option v-for="item in options" :key="item._id" :label="item.name" :value="item._id"></el-option>
		</el-select>
		<div
			class="text-muted text-small"
			v-if="params.tipShow && myValue[params.tipShow]"
		>{{params.tipShowName}} : {{myValue[params.tipShow]}}</div>
	</div>
</template>
<script>
import RelateInput from "@/mixins/RelateInput.js";
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
	mixins: [RelateInput],
	data() {
		return {
			loadings: {
				main: false,
				create: false,
			},
			dataModel: "Adminuser",
			editorId: "",
			editorVisible: false,
			editorFields: [
				{
					name: "name",
					col: 6,
					rules: ["required"],
				},
				{
					name: "intro",
					width: "100%",
					row: 3,
				},
			],
		};
	},
	computed: {
		...mapState(["userInfo"]),
	},
	props: {
		params: {
			type: Object,
			default: () => {
				return {
					tipShow: "",
					tipShowName: "",
					allowCreate: true,
					notUseMeAsDefault: false,
					placeholder: "请搜索",
				};
			},
		},
		nameFields: {
			type: Array,
			default: () => {
				return ["name"];
			},
		},
		value: {
			type: Object,
			default: () => {
				return {
					name: "",
					_id: "",
					balance: 0,
				};
			},
		},
		filter: {
			type: Object,
			default() {
				return {
					field: "is_leave",
					type: "bool",
					value: 0,
				};
			},
		},
	},
	mounted() {
		if (!this.value._id) {
			if (!this.params.notUseMeAsDefault) {
				this.id = this.userInfo.userId;
				this.onCreated({
					_id: this.userInfo.userId,
					name: this.userInfo.userName,
				});
			}
		}
	},
};
</script>
